import React from 'react';

const ICONS = {
    filter: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
        </svg>
    ),
    kpi: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
            <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
    ),
    tools: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
        </svg>
    ),
    default: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
    ),
};

export default function EmptyState({ icon, title, description, actions = [] }) {
    const iconEl = ICONS[icon] || ICONS.default;
    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', padding: '56px 32px', textAlign: 'center',
        }}>
            <div style={{ color: 'var(--ap-text-3, #94a3b8)', marginBottom: 16 }}>
                {iconEl}
            </div>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--ap-text, #1e293b)', marginBottom: 8 }}>
                {title}
            </div>
            {description && (
                <div style={{ fontSize: 13, color: 'var(--ap-text-3, #94a3b8)', maxWidth: 400, lineHeight: 1.6, marginBottom: actions.length ? 20 : 0 }}>
                    {description}
                </div>
            )}
            {actions.length > 0 && (
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
                    {actions.map((a, i) => (
                        <button
                            key={i}
                            onClick={a.onClick}
                            style={{
                                padding: '8px 18px', fontSize: 13, borderRadius: 6, cursor: 'pointer',
                                fontFamily: 'inherit', fontWeight: 600,
                                background: a.primary ? 'var(--ap-accent, #1b2a4a)' : 'transparent',
                                color: a.primary ? '#fff' : 'var(--ap-accent, #1b2a4a)',
                                border: a.primary ? 'none' : '1px solid var(--ap-accent, #1b2a4a)',
                            }}
                        >
                            {a.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
